
<ng-container
    [formGroup]="outletForm"
    class="agpr-targetingSearch-center"
>
    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer nameField">
        <div class="agpr-targetingSearch-mainFields-basicChips">
            <agpr-autocomplete-chips
                formControlName="outlets"
                [id]="id + '_outletNames'"
                header="Discover.targeting.searchFieldLabels.outlet.names"
                headerStyleClass="agpr-targetingSearch-fieldLabels"
                placeholder="Discover.targeting.searchFieldLabels.outletNames.placeholder"
                [itemTemplate]="itemTemplate"
                field="name"
                [autocompleteOptions]="outletNameAutocompleteOptions"
            >
                <ng-template let-item #itemTemplate>
                    @if (item?.entityType) {
                        <li
                            class="p-autocomplete-item agpr-targetingSearch-listItemContainer"
                            pRipple
                        >
                            <agpr-journodex-entity-list-item
                                [entity]="item"
                            ></agpr-journodex-entity-list-item>
                        </li>
                    }
                </ng-template>
            </agpr-autocomplete-chips>
        </div>
    </div>
    <div class="agpr-targetingSearch-mainFields">
        <div class="agpr-targetingSearch-mainFields-leftColumn">
            <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                <agpr-include-exclude-chips
                    formControlName="outletKeywords"
                    [id]="id + '_covering_includeExclude'"
                    [chipValidations]="keywordValidators"
                    headerLabel="Discover.targeting.searchFieldLabels.monitoringKeywords"
                    tooltip="Discover.targeting.searchFieldLabels.outlet.monitoringKeywords.tooltip"
                    placeholder="Discover.targeting.searchFieldLabels.monitoringKeywords.placeholder"
                    [splitOnPattern]="splitOnPattern"
                ></agpr-include-exclude-chips>
            </div>

            @if (
                (previewCount >= MAX_SEARCH_SIZE && !previewLoading) &&
                (outletKeywords.include.length > 0 || outletKeywords.exclude.length > 0 || outletKeywords.includeAll?.length > 0)
            ) {
                <div class="agpr-targetingSearch-message">
                    <agpr-message [severity]="messageSeverity.warning">
                        {{ 'Discover.targeting.searchFieldLabels.keywords.broad' | localize }}
                    </agpr-message>
                </div>
            }

            <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                <agpr-include-exclude-subject-chips
                    formControlName="outletSubjects"
                    [id]="id + '_outletSubject_includeExclude'"
                    headerLabel="Discover.targeting.searchFieldLabels.coveringSubjects"
                    tooltip="Discover.targeting.searchFieldLabels.outletContactCovering.tooltip"
                    placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                    (browseAll)="showSubjectsBrowser($event)"
                ></agpr-include-exclude-subject-chips>
            </div>
            <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                <agpr-include-exclude-chips
                    formControlName="geographies"
                    [id]="id + '_regions_includeExclude'"
                    headerLabel="Discover.targeting.searchFieldLabels.regions"
                    placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                    tooltip="Discover.targeting.searchFieldLabels.outletRegions.tooltip"
                    labelLookupField="displayString"
                    [showIncludeAll]="false"
                    [autocompleteOptions]="{
                        suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                        customOptions: [noContentMessages['region']]
                    }"
                    (browseAll)="showRegionBrowser(regionKey.geographies, $event)"
                ></agpr-include-exclude-chips>

                @if (geographies.errors?.['duplicateRegions']) {
                    <agpr-form-message [id]="id + '_geographies_error'">
                        {{ 'Discover.targeting.rhp.regionsConflictError' | localize }}
                    </agpr-form-message>
                }
            </div>
        </div>
        <div class="agpr-targetingSearch-mainFields-rightColumn">
            <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                    <agpr-include-exclude-chips
                        formControlName="areasOfCoverage"
                        [id]="id + '_areasOfCoverage_includeExclude'"
                        headerLabel="Discover.targeting.searchFieldLabels.targetAudienceRegion"
                        tooltip="Discover.targeting.searchFieldLabels.contactTargetAudienceRegion.tooltip"
                        placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                        labelLookupField="displayString"
                        [autocompleteOptions]="{
                            suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService),
                            customOptions: [noContentMessages['targetAudienceRegion']]

                        }"
                        (browseAll)="showRegionBrowser(regionKey.areasOfCoverage, $event)"
                    ></agpr-include-exclude-chips>
                </div>
                @if (hasMediaMarkets) {
                    <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                        <agpr-include-exclude-media-market-chips
                            formControlName="mediaMarkets"
                            [id]="id + '_outlet_mediaMarkets'"
                            (browseAll)="openMediaMarketDialog($event)"
                        ></agpr-include-exclude-media-market-chips>
                    </div>
                }
            </div>
            <div class="agpr-targetingSearch-mainFields-includeExcludeContainer">
                <agpr-include-exclude-chips
                    formControlName="languages"
                    [id]="id + '_languages_includeExclude'"
                    headerLabel="Discover.targeting.searchFieldLabels.languages"
                    placeholder="Discover.targeting.searchFieldLabels.search.placeholder"
                    labelLookupField="name"
                    [autocompleteOptions]="{
                        suggestionsFetcher: localizationService.autocompleteLanguages.bind(localizationService),
                        customOptions: [noContentMessages['language']]
                    }"
                    (browseAll)="showLanguageBrowser($event)"
                ></agpr-include-exclude-chips>
            </div>
        </div>
    </div>
</ng-container>

<ng-template let-item #noContentMessageTemplate>
    <agpr-message
        class="agpr-noContentMessage"
        [severity]="item.severity"
    >
        {{ item.noContentMessageLabel | localize }}
    </agpr-message>
</ng-template>
